/* eslint-disable no-param-reassign */
import React, { Dispatch, useState } from 'react';
import { View } from 'react-native';
import { t } from 'Locale';
import { withStore } from 'Store';
import { PlayerManager } from '@24i/react-native-player';
// eslint-disable-next-line import/no-unresolved
import { LanguageSettingsContext, StyleMap } from 'Types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { IAudioTrack, ITextTrack } from '@24i/player-base';
import SelectBox from 'LocalGluons/components/SelectBox';
import { useLanguageSettingsContext } from 'LocalGluons';
import Icon from '../../../Icon';
import { filterInvalidTextTracks } from '../../../PlayerContainer/playerUtils';
import playerModalStyles from '../PlayerModal/style';
import defaultStyles from './SettingsModal.jss';
import { getTrackLabel } from '../GetTrackLabel';

const OFF_ITEM_ID = 'off';

interface SettingsModalProps {
    onClose: () => void;
    style: StyleMap;
    playerInstance: PlayerManager;
    textTracks: ITextTrack[];
    audioTracks: IAudioTrack[];
    selectedAudioTrack: IAudioTrack;
    selectedTextTrack: ITextTrack | null;
    setSelectedTextTrack: Dispatch<ITextTrack>;
    setSelectedAudioTrack: Dispatch<IAudioTrack>;
}

// Whole container is upside down to prevent overflow issues with multiple drop downs
const SettingsModal = ({
    onClose,
    style,
    playerInstance,
    textTracks: playerTextTracks,
    audioTracks: playerAudioTracks,
    selectedAudioTrack,
    selectedTextTrack,
    setSelectedTextTrack,
    setSelectedAudioTrack
}: SettingsModalProps) => {
    const parseTextTracks = (unparsedTextTracks) => {
        const tracks = unparsedTextTracks || [];
        return tracks.map((textTrack) => ({
            ...textTrack,
            id: textTrack.id || textTrack.index,
            value: textTrack.index,
            title:
                textTrack.name ||
                textTrack.title ||
                textTrack.language?.toUpperCase() ||
                `${textTrack.index}`,
            label: textTrack.name || textTrack.title || textTrack.index,
            isSelected: !!textTrack.selected
            // selected: textTrack.selected
        }));
    };
    const parsedTextTracks = filterInvalidTextTracks(parseTextTracks(playerTextTracks));
    const [textTracks, setTextTracks] = useState([
        {
            id: OFF_ITEM_ID,
            label: t('COMMON.OFF'),
            title: t('COMMON.OFF'),
            value: t('COMMON.OFF'),
            selected: !selectedTextTrack
        },
        ...parsedTextTracks
    ]);

    const onSubtitleSelect = (item) => {
        const newTextTracks = textTracks.map((textTrack) => ({
            ...textTrack,
            selected: textTrack.id === item.id,
            isSelected: textTrack.id === item.id
        }));

        if (item.id === OFF_ITEM_ID || !item.selected) {
            playerInstance.textTrack = null;
            // setSelectedTextTrack(null);
            setTextTracks(newTextTracks);
            // playerInstance.hideTextTrack();
        } else {
            // TODO: FIX.. this is wrong
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            playerInstance.textTrack = item;
            setSelectedTextTrack(item);
            setTextTracks(newTextTracks);
        }
    };
    const parseAudioTracks = (unparsedTracks) => {
        const tracks = unparsedTracks || [];
        return tracks.map((audioTrack) => ({
            ...audioTrack,
            isSelected: !!audioTrack.selected,
            language: getTrackLabel(audioTrack)
        }));
    };

    const parsedAudioTracks = parseAudioTracks(playerAudioTracks);
    const {
        setSelectedPlayerAudioId,
        getAudioTrackLabel
    } = useLanguageSettingsContext() as LanguageSettingsContext;

    const [audioTracks, setAudioTracksParsed] = useState([...parsedAudioTracks]);

    const onSelectAudioTrack = (item: IAudioTrack) => {
        const newAudioTracks = audioTracks.map(audioTrack => ({
            ...audioTrack,
            selected: audioTrack.id === item.id
                ? !!setSelectedPlayerAudioId(audioTrack.language.toLowerCase())
                : false,
        }));
        playerInstance.audioTrack = item;
        setSelectedAudioTrack(item);
        setAudioTracksParsed(newAudioTracks);
        onClose();
    };
    const selectedAudioTracks = audioTracks.map(audioTrack =>
    ({
        ...audioTrack,
        isSelected: audioTrack.id === selectedAudioTrack.id,
        language: getAudioTrackLabel(audioTrack)
    })
    );

    // TO DO: textTracks doesn't have implementation
    const hasTextTracks = textTracks && textTracks.length > 1;
    const hasAudioTracks = audioTracks && audioTracks.length >= 1;

    return (
        <View style={[defaultStyles.container, style]}>
            {/* extra view to enable touchas outside root view on tablets */}
            <View style={defaultStyles.backgroundContainer} />

            <View style={defaultStyles.innerContainer}>
                {hasTextTracks && (
                    <SelectBox
                        heading={t('COMMON.SUBTITLES')}
                        onSelect={onSubtitleSelect}
                        // TODO: Fix
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        items={selectedTextTracks}
                    />
                )}
                {hasAudioTracks && (
                    <View style={defaultStyles.settingsContainerPadding}>
                        <SelectBox
                            heading={t('COMMON.AUDIO')}
                            onSelect={onSelectAudioTrack}
                            // TODO: Fix
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            items={selectedAudioTracks}
                        />
                    </View>
                )}
            </View>
            <Icon
                style={{ ...playerModalStyles.iconClose, ...defaultStyles.iconClose }}
                testID="close_button"
                name="close"
                onPress={onClose}
            />
        </View>
    );
};

export default withStore(SettingsModal);
